const languages = {
	en: 'en',
	ru: 'ru',
	de: 'de',
	pt: 'pt',
	fr: 'fr',
	hu: 'hu',
	hi: 'hi',
	bn: 'bn',
	zh: 'zh',
	bu: 'bu',
	tl: 'tl',
	ta: 'ta',
	sg: 'sg',
	es: 'es',
	id: 'id',
	it: 'it',
	ro: 'ro',
	th: 'th',
	pl: 'pl',
	el: 'el',
	ka: 'ka',
	az: 'az',
	bg: 'bg',
	si: 'sl',
	sk: 'sk',
	cz: 'cz',
	hr: 'hr',
	nl: 'nl',
	lv: 'lv',
	lt: 'lt',
	my: 'my',
	ee: 'ee',
	vi: 'vi',
	ar: 'ar',
	tr: 'tr',
	sv: 'sv',
	al: 'al'
};

const locale = {
	ru: {
		en: 'Английский',
		ru: 'Русский',
		de: 'Немецкий',
		pt: 'Португальский',
		fr: 'Французский',
		hu: 'Венгерский',
		es: 'Испанский',
		id: 'Индонезийский',
		it: 'Итальянский',
		ro: 'Румынский',
		th: 'Тайский',
		pl: 'Польский',
		el: 'Греческий',
		ka: 'Грузинский',
		az: 'Азербайджанский',
		bg: 'Болгарский',
		si: 'Словенский',
		sk: 'Словацкий',
		cz: 'Чешский',
		hr: 'Хорватский',
		nl: 'Голландский',
		lv: 'Латышский',
		hi: 'Хинди',
		bn: 'Бенгальский',
		zh: 'Китайский',
		bu: 'Бирманский',
		tl: 'Тагальский',
		ta: 'Тамильский',
		sg: 'Сингальский',
		lt: 'Литовский',
		my: 'Малайский',
		sv: 'Шведский',
		ee: 'Эстонский',
		vi: 'Вьетнамский',
		ar: 'Арабский',
		tr: 'Турецкий',
		al: 'Албанский'
	},
	en: {
		en: 'English',
		ru: 'Russian',
		de: 'German',
		pt: 'Portuguese',
		fr: 'French',
		hu: 'Hungarian',
		hi: 'Hindi',
		bn: 'Bengali',
		zh: 'Chinese',
		bu: 'Burmese',
		tl: 'Tagalog',
		ta: 'Tamil',
		sg: 'Sinhalese',
		es: 'Spanish',
		id: 'Indonesian',
		it: 'Italian',
		ro: 'Romanian',
		th: 'Thai',
		pl: 'Polish',
		el: 'Greek',
		ka: 'Georgian',
		az: 'Azerbaijani',
		bg: 'Bulgarian',
		si: 'Slovenian',
		sk: 'Slovak',
		cz: 'Czech',
		hr: 'Croatian',
		nl: 'Dutch',
		lv: 'Latvian',
		lt: 'Lithuanian',
		my: 'Malay',
		sv: 'Swedish',
		ee: 'Estonian',
		vi: 'Vietnamese',
		ar: 'Arabic',
		tr: 'Turkish',
		al: 'Albanian'
	},
	uk: {
		en: 'English',
		ru: 'Russian',
		de: 'German',
		pt: 'Portuguese',
		fr: 'French',
		hu: 'Hungarian',
		hi: 'Hindi',
		bn: 'Bengali',
		zh: 'Chinese',
		bu: 'Burmese',
		tl: 'Tagalog',
		ta: 'Tamil',
		sg: 'Sinhalese',
		es: 'Spanish',
		id: 'Indonesian',
		it: 'Italian',
		ro: 'Romanian',
		th: 'Thai',
		pl: 'Polish',
		el: 'Greek',
		ka: 'Georgian',
		az: 'Azerbaijani',
		bg: 'Bulgarian',
		si: 'Slovenian',
		sk: 'Slovak',
		cz: 'Czech',
		hr: 'Croatian',
		nl: 'Dutch',
		lv: 'Latvian',
		lt: 'Lithuanian',
		my: 'Malay',
		sv: 'Swedish',
		ee: 'Estonian',
		vi: 'Vietnamese',
		ar: 'Arabic',
		tr: 'Turkish',
		al: 'Albanian'
	},
	de: {
		en: 'English',
		ru: 'Russian',
		de: 'German',
		pt: 'Portuguese',
		fr: 'French',
		hu: 'Hungarian',
		hi: 'Hindi',
		bn: 'Bengali',
		zh: 'Chinesisch',
		bu: 'Birmanisch',
		tl: 'Tagalog',
		ta: 'Tamil',
		sg: 'Singhalesisch',
		es: 'Spanish',
		id: 'Indonesian',
		it: 'Italian',
		ro: 'Romanian',
		th: 'Thai',
		pl: 'Polish',
		el: 'Greek',
		ka: 'Georgian',
		az: 'Azerbaijani',
		bg: 'Bulgarisch',
		si: 'Slowenisch',
		sk: 'Slowakisch',
		cz: 'Tschechisch',
		hr: 'Kroatisch',
		nl: 'Niederländisch',
		lv: 'Latvian',
		lt: 'Lithuanian',
		my: 'Malaiisch',
		sv: 'Swedish',
		ee: 'Estonian',
		vi: 'Vietnamese',
		ar: 'Arabisch',
		tr: 'Türkisch',
		al: 'Albanisch'
	},
	vi: {
		en: 'English',
		ru: 'Russian',
		de: 'German',
		pt: 'Portuguese',
		fr: 'French',
		hu: 'Hungarian',
		hi: 'Hindi',
		bn: 'Bengali',
		zh: 'Chinese',
		bu: 'Burmese',
		tl: 'Tagalog',
		ta: 'Tamil',
		sg: 'Sinhalese',
		es: 'Spanish',
		id: 'Indonesian',
		it: 'Italian',
		ro: 'Romanian',
		th: 'Thai',
		pl: 'Polish',
		el: 'Greek',
		ka: 'Georgian',
		az: 'Azerbaijani',
		bg: 'Bulgarian',
		si: 'Slovenian',
		sk: 'Slovak',
		cz: 'Czech',
		hr: 'Croatian',
		nl: 'Dutch',
		lv: 'Latvian',
		lt: 'Lithuanian',
		my: 'Malay',
		sv: 'Swedish',
		ee: 'Estonian',
		vi: 'Vietnamese',
		ar: 'tiếng Ả Rập',
		tr: 'Thổ nhĩ kỳ',
		al: 'Albanian'
	},
	th: {
		en: 'อังกฤษ',
		ru: 'รัสเซีย',
		de: 'เยอรมัน',
		pt: 'โปรตุเกส',
		fr: 'ฝรั่งเศส',
		hu: 'ฮังการี',
		hi: 'ภาษาฮินดี',
		bn: 'ประเทศบังคลาเทศ',
		zh: 'ชาวจีน',
		bu: 'พม่า',
		tl: 'ตากาล็อก',
		ta: 'ทมิฬ',
		sg: 'สิงหล',
		es: 'สเปน',
		id: 'ชาวอินโดนีเซีย',
		it: 'อิตาลี',
		ro: 'โรมาเนีย',
		th: 'ไทย',
		pl: 'โปแลนด์',
		el: 'กรีก',
		ka: 'จอร์เจีย',
		az: 'อาเซอร์ไบจาน',
		bg: 'บัลแกเรีย',
		si: 'ภาษาสโลเวเนีย',
		sk: 'สโลวาเกีย',
		cz: 'สาธารณรัฐเช็ก',
		hr: 'โครเอเชีย',
		nl: 'ดัตช์',
		lv: 'ลัตเวีย',
		lt: 'ภาษาลิธัวเนีย',
		my: 'ภาษามลายู',
		sv: 'Swedish',
		ee: 'เอสโตเนีย',
		vi: 'เวียตนาม',
		ar: 'ภาษาอาหรับ',
		tr: 'ภาษาตุรกี',
		al: 'แอลเบเนีย'
	}
};

module.exports = {
	enum: languages,
	locale: locale
};



// WEBPACK FOOTER //
// ./enums/landing-languages.js